"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    handleButtonClick: function() {
        return handleButtonClick;
    },
    openModal: function() {
        return openModal;
    },
    closeModal: function() {
        return closeModal;
    }
});
function handleButtonClick(event) {
    if (this.isModalOpen()) {
        this.closeModal();
        this.fire("close", {
            Modal: this
        });
    } else {
        this.openModal();
        this.fire("open", {
            Modal: this
        });
    }
}
function openModal() {
    if (!this.isModalOpen()) {
        this.modal.classList.add("open");
        if (this.config.attributes) {
            this.modal.setAttribute("open", "");
        }
        this.backdrop.showBackdrop();
        this.modal.dispatchEvent(new CustomEvent("wr-modal-shown", {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
        document.body.dispatchEvent(new CustomEvent("wr-modal-shown", {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
    }
}
function closeModal() {
    if (this.isModalOpen()) {
        this.modal.classList.remove("open");
        if (this.config.attributes) {
            this.modal.removeAttribute("open");
        }
        this.backdrop.fire("hide");
        this.modal.dispatchEvent(new CustomEvent("wr-modal-hidden", {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
        document.body.dispatchEvent(new CustomEvent("wr-modal-hidden", {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
    }
}
